/**
 * Selector de período genérico de las Estadísticas avanzadas (presentacional).
 *
 * Réplica de las pestañas del SSR (`advanced_stats_with_charts.html`): el panel
 * global y cada gráfica tienen su juego de períodos. Se parametriza por el tipo del
 * valor (`day`/`week`/`month`/`year` según la gráfica) para reutilizar el mismo
 * control con seguridad de tipos. Sin lógica de datos: recibe el período activo y
 * sus opciones, y notifica el cambio al padre (que recarga la serie: la query key
 * incluye el período).
 */
import { Button } from "@/components/ui";

import type { PeriodOption } from "../constants";

interface PeriodTabsProps<T extends string> {
  value: T;
  options: PeriodOption<T>[];
  onChange: (period: T) => void;
  /** Etiqueta accesible del grupo (p. ej. "Período de ingresos"). */
  ariaLabel: string;
}

export function PeriodTabs<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
}: PeriodTabsProps<T>) {
  return (
    <div
      className="flex flex-wrap gap-1 rounded-lg border border-slate-200 bg-white p-1"
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={option.value === value ? "primary" : "ghost"}
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
